// Definição para o modal de busca de Condições de Pagamento
// Factory function - recebe filtros como parâmetros, sem magic strings

import { ST } from '@/constants/ST'

export const criarConfigBuscaCondicaoPagamento = (lstStatus = ST.Ativo) => ({
  label: 'Condição de Pagamento',
  placeholder: 'ID ou Descrição...',
  titulo: 'Selecionar Condição de Pagamento',
  endpointApi: 'CondicoesPagamento',
  idField: 'idCondicaoPagamento',
  displayField: 'idCondicaoPagamento',
  descField: 'descricao',
  camposFiltro: [
    { label: 'ID', model: 'idCondicaoPagamento', tipo: 'text' },
    { label: 'Descrição', model: 'busca', tipo: 'text' },
    { label: 'Parcelas', model: 'quantidadeParcelas', tipo: 'text' },
    { label: 'Intervalo (dias)', model: 'diasIntervalo', tipo: 'text' },
    { label: 'Dia Fixo', model: 'diaFixoVencimento', tipo: 'text' },
    {
      label: 'Entrada',
      model: 'entrada',
      tipo: 'select',
      options: [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' }
      ]
    }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idCondicaoPagamento', width: '10%' },
    { header: 'Descrição', dataField: 'descricao', width: '30%' },
    { header: 'Parcelas', dataField: 'quantidadeParcelas', width: '12%' },
    { header: 'Intervalo (dias)', dataField: 'diasIntervalo', width: '15%' },
    { header: 'Dia Fixo', dataField: 'diaFixoVencimento', width: '10%' },
    { header: 'Entrada', dataField: 'entrada', width: '10%' }
  ],
  filtrosFixos: {
    lstStatus
  }
})
